const riot = require('riot');

riot.tag2('page-paypay-receive', '<div class="s-full min-height-100per" if="{event}"> <div class="f fclm container-538 s-full s-px24"> <div class="f fclm fh h-full"> <div class="container-240 p0 mb16 mtn8"><img class="block w-full object-fit-contain" src="/images/paypay/paypay_logo.png" alt="paypayのロゴ"></div> <p class="white-space-pre-wrap text-center text-navy ts-hs mb24">{error ? ⁗連携に失敗しました。⁗ : ⁗連携が完了しました。\\n特典が付与されます。⁗}</p> <p class="text-center text-gray_80 ts-ps" if="{!error}">このページを閉じてしばらくお待ちください。</p> <p class="text-center text-gray_80 ts-ps" if="{error}">このページを閉じて、受け取りURLより再度アクセス<br class="s-show">してください。</p> </div> <module-footer class="mb32" event="{event}" is-email-terms-hidden="{event.point_provider === &quot;paypay&quot;}"></module-footer> </div> </div>', 'page-paypay-receive,[data-is="page-paypay-receive"]{display:block}', '', function(opts) {

    this.event = undefined;

    this.preload = async ({req}) => {
      const onetime_hash = req.query.hash;
      if (!onetime_hash) throw { status: 404 };

      const event = await app.api.child('distribution_events:getByOnetimeHash').get({
        onetime_hash,
      });

      if (!req.query.responseToken) {

        var error = { status: 404, message: '認証情報の取得に失敗しました' };
        return {
          event,
          error,
        };
      }
      try {
        await app.api.child('paypay/publish').post({
          authorization_response_token: req.query.responseToken,
        });
      }
      catch(e) {
        var error = e;
        console.error(e);
      }
      return {
        event,
        error,
      };
    };

    this.head = () => {
      return {
        title: `${!this.error ? 'PayPay受け取り申請完了': 'PayPay受け取り申請失敗'} | Repro Incentive`,

        description: '',
        ogp: {
          image: '',
        }
      };
    };
});